var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-tooltip__wrapper",on:{"mouseenter":function($event){!_vm.clickTrigger ? _vm.handleTrigger($event) : () => null},"mouseleave":function($event){!_vm.clickTrigger ? _vm.closeTooltip() : () => null},"click":function($event){_vm.clickTrigger ? _vm.handleTrigger($event) : () => null}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }